/**
 * Shared filtering configuration for Elasticsearch queries
 * Handles conditional region and brand filtering based on ACF settings
 */

interface ElasticFilter {
  term?: { [field: string]: string };
}

/**
 * Creates conditional filters based on region and brand ACF settings
 * Returns an array of filters to be applied to Elasticsearch must_not or must clauses
 */
export const createConditionalFilters = (): ElasticFilter[] => {
  const filters: ElasticFilter[] = [];
  
  const region = window.aqJobsOptions?.region;
  const brand = window.aqJobsOptions?.brand;

  // Add region filter if not "all"
  if (region && region !== 'all') {
    filters.push({
      term: { 'region.enum': region }
    });
  }

  // Add brand filter if not "all"
  if (brand && brand !== 'all') {
    filters.push({
      term: { 'brand.enum': brand }
    });
  }

  return filters;
};

/**
 * Applies conditional filters to an existing Elasticsearch query
 * Modifies the query in place by adding filters to the bool.must clause
 * Handles both pre-constructed queries and search-ui generated queries
 */
export const applyConditionalFilters = (query: any): void => {
  const conditionalFilters = createConditionalFilters();
  
  if (conditionalFilters.length === 0) {
    return; // No filters to apply
  }

  // Handle different query structures
  if (!query) {
    return;
  }

  // Ensure query has proper bool structure
  if (!query.bool) {
    query.bool = {};
  }
  
  if (!query.bool.must) {
    query.bool.must = [];
  }

  // Add conditional filters to must clause
  query.bool.must.push(...conditionalFilters);
};